// extracted by mini-css-extract-plugin
export default {"filePreview":"DownloadFilePage_filePreview__Sn7bj","info":"DownloadFilePage_info__lc9kZ","fileName":"DownloadFilePage_fileName__GidIR","size":"DownloadFilePage_size__lQPl-"};